( function( $ ) {
    "use strict";

    var _events = {
        onStoreCalendarUser: function() {
            var $button = $(this);

            function revert() {
                $button.show();
            }

            $button.prop('disabled', true);

            $.App.api('POST', 'calendar-users', {resource: $button.data('api-data')})
                .done(function(response) {
                    if (!response.success) {
                        console.warn('App api error: POST calendar-users');
                        return revert();
                    }

                    window.location.ajax(window.location.href);
                })
                .fail(function() {
                    return revert();
                });
        },

        onDestroyCalendarUser: function() {
            var $button = $(this);

            function revert() {
                $button.show();
            }

            $button.prop('disabled', true);

            $.App.api('DELETE', 'calendar-users/'+$button.data('api-resource'))
                .done(function (response) {
                    if (!response.success) {
                        console.warn('App api error: DELETE calendar-users/' + $button.data('api-resource'));
                        return revert();
                    }

                    window.location.ajax(window.location.href);
                })
                .fail(function () {
                    return revert();
                });
        },

        onActivateCompany: function () {
            var $button = $(this);

            function revert() {
                $button.show();
            }

            $button.prop('disabled', true);

            $.App.api('PATCH', 'companies/'+$button.data('api-resource')+'/activate')
                .done(function(response) {
                    if (!response.success) {
                        console.warn('App api error: PATCH companies/'+$button.data('api-resource')+'/activate');
                        return revert();
                    }

                    window.location.ajax(window.location.href);
                })
                .fail(function() {
                    return revert();
                });
        },

        onDeactivateCompany: function() {
            var $button = $(this);

            function revert() {
                $button.show();
            }

            $button.prop('disabled', true);

            $.App.api('PATCH', 'companies/'+$button.data('api-resource')+'/deactivate')
                .done(function(response) {
                    if (!response.success) {
                        console.warn('App api error: PATCH companies/'+$button.data('api-resource')+'/deactivate');
                        return revert();
                    }

                    window.location.ajax(window.location.href);
                })
                .fail(function() {
                    return revert();
                });
        },

        onActivatePerson: function() {
            var $button = $(this);

            function revert() {
                $button.show();
            }

            $button.prop('disabled', true);

            $.App.api('PATCH', 'people/'+$button.data('api-resource')+'/activate')
            .done(function(response) {
                if (!response.success) {
                    console.warn('App api error: PATCH people.deactivate');
                    return revert();
                }

                window.location.ajax(window.location.href);
            })
            .fail(function() {
                return revert();
            });
        },

        onDeactivatePerson: function() {
            var $button = $(this);

            function revert() {
                $button.show();
            }

            $button.prop('disabled', true);

            $.App.api('PATCH', 'people/'+$button.data('api-resource')+'/deactivate')
            .done(function(response) {
                if (!response.success) {
                    console.warn('App api error: PATCH people.deactivate');
                    return revert();
                }

                window.location.ajax(window.location.href);
            })
            .fail(function() {
                return revert();
            });
        }
    };

    var $body = $('body');

    $body.on('app.ready', function() {
        $body.on('click', '[data-api-action="store:calendar-user"]', _events.onStoreCalendarUser);
        $body.on('click', '[data-api-action="destroy:calendar-user"]', _events.onDestroyCalendarUser);
        $body.on('click', '[data-api-action="activate:person"]', _events.onActivatePerson);
        $body.on('click', '[data-api-action="deactivate:person"]', _events.onDeactivatePerson);
        $body.on('click', '[data-api-action="activate:company"]', _events.onActivateCompany);
        $body.on('click', '[data-api-action="deactivate:company"]', _events.onDeactivateCompany);
    });

}( jQuery ));
